import { MapContainer } from "react-leaflet";

import MapCachedTileLayer from "../../MapComponents/Leaflet/Layers/mapCachedTileLayer";
import MapZoomControls from "../../MapComponents/Leaflet/Controls/mapZoomControls";
import { IMainMap } from "../hooks/useMainMap";
import MapInit from "./MapInit";


interface MainMapProps {
    state: IMainMap;
    children?: React.ReactNode;
}

const MainMap = ({ state, children }: MainMapProps): JSX.Element => {

    return (
        
        <MapContainer 
            scrollWheelZoom={true} 
            touchZoom={true}
            maxBounds={state.maxBounds} 
            attributionControl={false}
            preferCanvas={true}
            bounceAtZoomLimits={true}
            zoomControl={false}
        >

            <MapInit state={state} />

            <MapCachedTileLayer
                layerInfo={state.currentTileLayer}
                tileCache={state.tileCache}
            />

            <MapZoomControls 
                layerInfo={state.currentTileLayer}
            />

            {/* <AttributionControl prefix=""/> */}

            {children}

        </MapContainer>
    );

};

export default MainMap;